import { configureStore } from '@reduxjs/toolkit';
import authReducer from './reducers/authSlice';
import businessReducer from './reducers/businessSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    business: businessReducer,
  },
});

